import axios from 'axios';
import { map } from 'lodash';
import { GeneralInfoData, StatisticData } from 'mobx/dataStore';
import { DtpCategoryStatItemData } from 'mobx/models/dtpCategoryStatItem';
import { nbsp } from 'utils/constants';

const fixMap: Record<string, string> = {
  'Наезд на пешехода': `Наезд на${nbsp}пешехода`,
  'Наезд на стоящее ТС': `Наезд на${nbsp}стоящее${nbsp}ТС`,
  'Наезд на велосипедиста': `Наезд на${nbsp}велосипедиста`,
  'Наезд на препятствие': `Наезд на${nbsp}препятствие`,
};

export const urlPrefix = process.env.REACT_APP_URL_PREFIX;

export const APIBaseURL =
  window.location.hostname === 'localhost' ? 'https://gucodd.ru' : '/';

export const axiosV0 = axios.create();
axiosV0.defaults.baseURL = APIBaseURL;

export const getCategoryStats = async () => {
  const res = await axiosV0.get<StatisticData>(`/dtp/year_dtp_stats`);

  // MOCK
  res.data.social_risk = 2.3;
  res.data.transport_risk = 0.6;

  return res.data;
};

export const fetchGeneralInfo = async () => {
  const res = await axiosV0.get<GeneralInfoData>('/dtp/general_info');

  return {
    categories: res.data.categories.map((category) => {
      return { ...category, name: fixMap[category.name] || category.name };
    }),
  };
};

export const getChartData = async () => {
  const res = await axiosV0.get<DtpCategoryStatItemData[]>(
    `/dtp/category_dtp_stats`
  );

  return res.data;
};
